const journalWebsite = () => import('../views/publishing/journal-website')
const basicInformation = () =>
  import('../views/publishing/journal-website/basic-information')
const highlights = () =>
  import('../views/publishing/journal-website/highlights')
const announcement = () =>
  import('../views/publishing/journal-website/announcement')
const sections = () => import('../views/publishing/journal-website/sections')
const journalMenu = () =>
  import('../views/publishing/journal-website/journal-menu')
const socialCollabrations = () =>
  import('../views/publishing/journal-website/social-collabrations')
const database = () => import('../views/publishing/journal-website/database')
const conferences = () =>
  import('../views/publishing/journal-website/conferences')

const subscribe = () => import('../views/editorial-office/subscribe')

const journal = () => import('../views/publishing/journals')
const journalAdd = () => import('../views/publishing/journals/add')

const publishing = () => import('../views/publishing/publication')
const publishingAdd = () => import('../views/publishing/publication/add')

const volumeIssue = () => import('../views/publishing/volume-issue')
const volumeIssueArticle = () =>
  import('../views/publishing/volume-issue/article')

const editorialBoard = () => import('../views/publishing/editorial-board')
const boardDetail = () => import('../views/user-manage/detail')
const personalInformation = () =>
  import('../views/user-manage/detail/personal-information')
const dataAnalysis = () =>
  import('../views/user-manage/detail/personal-information')
const relatedManuscripts = () =>
  import('../views/user-manage/detail/personal-information')
const relatedSpecialIssue = () =>
  import('../views/user-manage/detail/personal-information')

const application = () =>
  import('../views/publishing/editorial-board/application')
const reviewerBoard = () => import('../views/publishing/reviewer-board')

const specialIssue = () => import('../views/publishing/special-issue')
const specialIssueAdd = () => import('../views/publishing/special-issue/add')
const specialIssueArticle = () =>
  import('../views/publishing/special-issue/article')
const specialIssueApplication = () =>
  import('../views/publishing/special-issue/application')
const topics = () => import('../views/publishing/topics')
const topicsAdd = () => import('../views/publishing/topics/add')
const topicsArticle = () => import('../views/publishing/topics/article')

const path = '/publishing'

export default [
  {
    path: path + '/publication',
    component: publishing,
    name: '/publishing/publication'
  },
  {
    path: path + '/publication/add',
    component: publishingAdd,
    name: '/publishing/publication/add'
  },
  {
    path: path + '/publication/:id',
    component: publishingAdd,
    name: '/publishing/publication/:id'
  },
  {
    path: path + '/journals',
    component: journal,
    name: '/publishing/journals'
  },
  {
    path: path + '/journals/add',
    component: journalAdd,
    name: '/publishing/journals/add'
  },
  {
    path: path + '/journals/add/:id',
    component: basicInformation,
    name: '/publishing/journals/add/:id'
  },
  {
    path: path + '/journals/:id',
    component: basicInformation,
    name: '/publishing/journals/:id'
  },
  {
    path: path + '/journal-website',
    component: journalWebsite,
    name: '/publishing/journal-website',
    children: [
      {
        path: path + '/journal-website/basic-information',
        component: basicInformation,
        name: '/publishing/journal-website/basic-information'
      },
      {
        path: path + '/journal-website/highlights',
        component: highlights,
        name: '/publishing/journal-website/highlights'
      },
      {
        path: path + '/journal-website/announcement',
        component: announcement,
        name: '/publishing/journal-website/announcement'
      },
      {
        path: path + '/journal-website/journal-menu',
        component: journalMenu,
        name: '/publishing/journal-website/journal-menu'
      },
      {
        path: path + '/journal-website/sections',
        component: sections,
        name: '/publishing/journal-website/sections'
      },
      {
        path: path + '/journal-website/social-collabrations',
        component: socialCollabrations,
        name: '/publishing/journal-website/social-collabrations'
      },
      {
        path: path + '/journal-website/database',
        component: database,
        name: '/publishing/journal-website/database'
      },
      {
        path: path + '/journal-website/conferences',
        component: conferences,
        name: '/publishing/journal-website/conferences'
      }
    ]
  },
  {
    path: path + '/subscribe',
    component: subscribe,
    name: '/publishing/subscribe'
  },
  {
    path: path + '/volume-issue',
    component: volumeIssue,
    name: '/publishing/volume-issue'
  },
  {
    path: path + '/volume-issue/articles/:id',
    component: volumeIssueArticle,
    name: '/publishing/volume-issue/articles/:id'
  },
  {
    path: path + '/editorial-board',
    component: editorialBoard,
    name: '/publishing/editorial-board'
  },
  {
    path: path + '/editorial-board/application',
    component: application,
    name: '/publishing/editorial-board/application'
  },
  {
    path: path + '/editorial-board/:id',
    component: boardDetail,
    name: '/publishing/editorial-board/:id',
    children: [
      {
        path: path + '/editorial-board/:id/personal-information',
        component: personalInformation,
        name: '/publishing/editorial-board/:id/personal-information'
      },
      {
        path: path + '/editorial-board/:id/data-analysis',
        component: dataAnalysis,
        name: '/publishing/editorial-board/:id/data-analysis'
      },
      {
        path: path + '/editorial-board/:id/related-manuscripts',
        component: relatedManuscripts,
        name: '/publishing/editorial-board/:id/related-manuscripts'
      },
      {
        path: path + '/editorial-board/:id/related-special-issue',
        component: relatedSpecialIssue,
        name: '/publishing/editorial-board/:id/related-special-issue'
      }
    ]
  },
  {
    path: path + '/reviewer-board',
    component: reviewerBoard,
    name: '/publishing/reviewer-board'
  },
  {
    path: path + '/reviewer-board/:id',
    component: boardDetail,
    name: '/publishing/reviewer-board/:id',
    children: [
      {
        path: path + '/reviewer-board/:id/personal-information',
        component: personalInformation,
        name: '/publishing/reviewer-board/:id/personal-information'
      },
      {
        path: path + '/reviewer-board/:id/data-analysis',
        component: dataAnalysis,
        name: '/publishing/reviewer-board/:id/data-analysis'
      },
      {
        path: path + '/reviewer-board/:id/related-manuscripts',
        component: relatedManuscripts,
        name: '/publishing/reviewer-board/:id/related-manuscripts'
      },
      {
        path: path + '/reviewer-board/:id/related-special-issue',
        component: relatedSpecialIssue,
        name: '/publishing/reviewer-board/:id/related-special-issue'
      }
    ]
  },
  {
    path: path + '/special-issue',
    component: specialIssue,
    name: '/publishing/special-issue'
  },
  {
    path: path + '/special-issue/add',
    component: specialIssueAdd,
    name: '/publishing/special-issue/add'
  },
  {
    path: path + '/special-issue/application',
    component: specialIssueApplication,
    name: '/publishing/special-issue/application'
  },
  {
    path: path + '/special-issue/application/:id',
    component: specialIssueAdd,
    name: '/publishing/special-issue/application/:id'
  },
  {
    path: path + '/special-issue/:id',
    component: specialIssueArticle,
    name: '/publishing/special-issue/:id'
  },
  {
    path: path + '/special-issue/edit/:id',
    component: specialIssueAdd,
    name: '/publishing/special-issue/edit/:id'
  },

  // topic
  {
    path: path + '/topics',
    component: topics,
    name: '/publishing/topics'
  },
  {
    path: path + '/topics/add',
    component: topicsAdd,
    name: '/publishing/topics/add'
  },
  {
    path: path + '/topics/edit/:id',
    component: topicsAdd,
    name: '/publishing/topics/edit/:id'
  },
  {
    path: path + '/topics/:id',
    component: topicsArticle,
    name: '/publishing/topics/:id'
  }
]
